module.exports = __webpack_public_path__ + "img/2020-5min-en.cd27a716.jpg";